import { EventEmitter, Injectable, Output } from '@angular/core';
import { CtaAction } from '../models/cta.action';

@Injectable({
  providedIn: 'root',
})
export class BaryCtaMenuService {
  @Output() onContextMenuItemClick?: EventEmitter<any>;

  private dropdownMenuHtmlElement = this.getDropdownMenuHtmlElement();
  private outsideClickListener?: (e: MouseEvent) => any;

  showCtaMenu(ctaActions: CtaAction[], currentTarget: HTMLElement, options?: { textRight: boolean }): void {
    const dropdownMenu = this.getDropdownMenuHtmlElement();
    this.onContextMenuItemClick = new EventEmitter<any>();

    // reset CTA Menu
    dropdownMenu.innerHTML = '';

    // ajout des actions
    ctaActions.forEach(action => {
      this.appendToMenu(action, dropdownMenu);
    });

    // détermination de la position Y
    const limit = ctaActions.length > 5 ? 4 * 40 + 55 : ctaActions.length * 40 + 55; // détermine quand le dropup doit être en place

    // Rendre le menu déroulant
    if (ctaActions.length > 5) {
      dropdownMenu.style.overflowY = 'scroll';
      dropdownMenu.style.height = '13em';
    }

    if (currentTarget.getBoundingClientRect().top + limit > window.innerHeight) {
      dropdownMenu.style.top = currentTarget.getBoundingClientRect().top - 25 - limit + window.scrollY + 'px';
    } else {
      dropdownMenu.style.top = currentTarget.getBoundingClientRect().top - 25 + window.scrollY + 'px';
    }

    // Détermination de la position X
    if (options?.textRight) {
      dropdownMenu.classList.add('text-left');
      dropdownMenu.style.left = currentTarget.getBoundingClientRect().left - (160 /* width du dropdown*/ - currentTarget.offsetWidth) + window.scrollX + 'px';
    } else {
      dropdownMenu.style.left = currentTarget.getBoundingClientRect().left + window.scrollX + 'px';
    }

    this.showCtaMenuDropdown();
    this.addCloseListener(currentTarget);
  }

  private appendToMenu(action: CtaAction, dropdownMenu: HTMLElement): void {
    const itemSpan = document.createElement('span');
    if (!action.action) {
      itemSpan.classList.add('text-muted');
    }
    if (action.dataIdCypress) {
      itemSpan.setAttribute('data-id-cypress', action.dataIdCypress);
    }
    itemSpan.classList.add('p-2', 'dropdown-item');
    itemSpan.innerHTML = `${action.icon ? `<i class="mx-2 fas ` + action.icon + `"></i>` : ''} ${action.label ?? ''}`;
    itemSpan.title = action.tooltip ? action.tooltip : '';
    if (!action.disabled) {
      itemSpan.onclick = (): void => {
        this.onContextMenuItemClick?.next(action);
        this.removeCloseListener();
      };
    } else {
      itemSpan.classList.add('text-muted');
    }

    dropdownMenu.appendChild(itemSpan);
  }

  private getDropdownMenuHtmlElement(): HTMLElement {
    return document.body.querySelector('#bary-cta-menu .dropdown-menu')!;
  }

  private addCloseListener(targetBtn: HTMLElement): void {
    document.addEventListener(
      'click',
      (e: MouseEvent) => {
        if ((e.target !== this.dropdownMenuHtmlElement || e.target !== targetBtn) && this.dropdownMenuHtmlElement.style.display === 'block') {
          this.closeCtaMenuDropdown();
        }
      },
      { once: true }
    );
  }

  private removeCloseListener(): void {
    if (this.outsideClickListener) {
      document.removeEventListener('click', this.outsideClickListener);
    }
  }

  private closeCtaMenuDropdown(): void {
    this.dropdownMenuHtmlElement.style.display = 'none';
  }

  private showCtaMenuDropdown(): void {
    this.dropdownMenuHtmlElement.style.display = 'block';
  }
}
